// extracted by mini-css-extract-plugin
module.exports = {"drugAlertForm":"admin-portal__DrugAlertEdit__drugAlertForm","buttonRow":"admin-portal__DrugAlertEdit__buttonRow","shrink":"admin-portal__DrugAlertEdit__shrink"};